import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { CoreModule } from '@core/core.module';
import { EditorModule } from '@tinymce/tinymce-angular';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NotesComponent } from 'src/app/private/sale/top-nav-bar/notes/notes.component';
import { AtomicModule } from '../atomic/atomic.module';
import { ActingForDropdownComponent } from './acting-for-dropdown/acting-for-dropdown.component';
import { BusinessDocumentEditorComponent } from './business-document-editor/business-document-editor.component';
import { BusinessUserFilterComponent } from './business-user-filter/business-user-filter.component';
import { BusinessUserSelectDropdownComponent } from './business-user-select-dropdown/business-user-select-dropdown.component';
import { BusinessUserSelectComponent } from './business-user-select/business-user-select.component';
import { BusinessUserComponent } from './business-user/business-user.component';
import { CompanyAddComponent } from './company-add/company-add.component';
import { ContactAdminUsersComponent } from './contact-admin-users/contact-admin-users.component';
import { CreateEmployeeComponent } from './create-employee/create-employee.component';
import { DocumentDialogComponent } from './document-dialog';
import { DocumentTreeComponent } from './document-tree/document-tree.component';
import { DocumentSettingsComponent } from './documents-matter-editor/document-settings/document-settings.component';
import { DocumentsMatterEditorComponent } from './documents-matter-editor/documents-matter-editor.component';
import { DocumentsMatterViewerComponent } from './documents-matter-viewer/documents-matter-viewer.component';
import { DocumentsMatterViewtorComponent } from './documents-matter-viewtor/documents-matter-viewtor.component';
import { EncryptedInputComponent } from './encrypted-input/encrypted-input.component';
import { ClientIdUploadComponent } from './file-upload/client-id-upload/client-id-upload.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { SaleFileUploadComponent } from './file-upload/sale-file-upload/sale-file-upload.component';
import { UploadFileStatusComponent } from './file-upload/upload-file-status/upload-file-status.component';
import { HtmlEditorComponent } from './html-editor/html-editor.component';
import { HtmlMiniEditorComponent } from './html-editor/html-mini-editor/html-mini-editor.component';
import { TagsDefinitionDialogComponent } from './html-editor/tags-definition-dialog/tags-definition-dialog.component';
import { MatterHtmlPdfViewerComponent } from './html-pdf-viewer/html-pdf-viewer.component';
import { LawyerClerkInitialsComponent } from './lawyer-clerk-initials/lawyer-clerk-initials.component';
import { LenderComponent } from './lender/lender.component';
import { LoadingComponent } from './loading/loading.component';
import { MatterFormViewerComponent } from './matter-form-viewer/matter-form-viewer.component';
import { MatterStatusIndicatorComponent } from './matter-status-indicator/matter-status-indicator.component';
import { MatterUrlPdfViewerComponent } from './matter-url-pdf-viewer/matter-url-pdf-viewer.component';
import { MatterUserSelectOrSearchComponent } from './matter-user-select-or-search/matter-user-select-or-search.component';
import { MultipleUrlPdfViewerComponent } from './multiple-url-pdf-viewer/multiple-url-pdf-viewer.component';
import { MultipleUserSearchComponent } from './multiple-user-search/multiple-user-search.component';
import { PdfModalComponent } from './pdf-modal/pdf-modal.component';
import { PdftronComponent } from './pdf-modal/pdftron/pdftron.component';
import { ProceedModalComponent } from './proceed-modal/proceed-modal.component';
import { ProgressCircleComponent } from './progress-circle/progress-circle.component';
import { CreateCompanySideFormComponent } from './side-form/create-company/create-company-side-form.component';
import { CreateEmployeeSideFormComponent } from './side-form/create-employee/create-employee-side-form.component';
import { SideFlyOutComponent } from './table/side-fly-out/side-fly-out.component';
import { UserPresenceComponent } from './user-presence/user-presence.component';
import { ViewAsDropdownComponent } from './view-as-dropdown/view-as-dropdown.component';
import { TableGeneratorDialogComponent } from './html-editor/table-generator-dialog/table-generator-dialog.component';
import { MatterFormViewerModalComponent } from './matter-form-viewer/matter-form-viewer-modal/matter-form-viewer-modal.component';
import { MatterTileComponent } from './matter-tile/matter-tile.component';
import { MatterTypeIconComponent } from './matter-type-icon/matter-type-icon.component';
import { MatterCountIconsComponent } from './matter-count-icons/matter-count-icons.component';
import { MatterPreviewComponent } from './matter-preview/matter-preview.component';
import { ContactNameBadgeComponent } from './contact-name-badge/contact-name-badge.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { LenderSelectorComponent } from './lender-selector/lender-selector.component';
import { LenderSearchInputComponent } from './searchable-fields/lender-search-input/lender-search-input.component';
import { LenderSearchInputV2Component } from './searchable-fields/lender-search-input-v2/lender-search-input.component';
import { FinancialInstitutionBranchSearchComponent } from './searchable-fields/branch-search/branch-search.component';
import { LenderCardComponent } from './lender-card/lender-card.component';
import { InstitutionCardComponent } from './institution-card/institution-card.component';
import { ContactDetailsComponent } from './institution-card/contact-details/contact-details.component';
import { ClientSearchInputComponent } from './searchable-fields/client-search-input/client-search-input.component';
import { ClientLenderCardComponent } from './lender-card/client-lender-card/client-lender-card.component';
import { MatterFormViewerContainerComponent } from './matter-form-viewer-container/matter-form-viewer-container.component';
import { InstitutionImgComponent } from './institution-card/institution-img/institution-img.component';
import { InvestorCardComponent } from './institution-card/investor-card/investor-card.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgClickOutsideDirective } from 'ng-click-outside2';
import { PayoutMessageComponent } from './institution-card/payout-message/payout-message.component';
import { EncumbranceInstitutionCardComponent } from './institution-card/encumbrance-institution-card/encumbrance-institution-card.component';
import { InsitutionSearchComponent } from 'src/app/private/sale/encumbrances/encumbrance/components/institution/search/search.component';
import { MatterStatusTileComponent } from './matter-status-tile/matter-status-tile.component';
import { GoogleImageComponent } from './google-image/google-image.component';
import { PoweredByTreefortComponent } from './powered-by-treefort/powered-by-treefort.component';
import { FormInstanceViewerComponent } from './matter-form-instance-viewer/matter-form-instance-viewer.component';
import { ShortfallExcessConformationModalComponent } from '@components/documents-matter-viewer/shortfall-excess-conformation-modal/shortfall-excess-conformation-modal.component';
import { UiModule } from 'src/app/ui/ui.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { StewartOAuthLoginComponent } from '@components/stewart-oauth-login/stewart-oauth-login.component';
import { LogoDrawerComponent } from './logo-drawer/logo-drawer.component';
import { MatterFileCardComponent } from './matter-file-card/matter-file-card.component';
import { AddressComponent } from './address/address.component';
import { DocumentTreeWordComponent } from './document-tree-word/document-tree-word.component';
import { BusinessUserDropdownComponent } from './business-user-dropdown/business-user-dropdown.component';
import { AiDocumentProcessingProgressBarComponent } from './ai-document-processing-progress-bar/ai-document-processing-progress-bar.component';
import { DocumentsWordMatterViewerComponent } from './documents-word-matter-viewer/documents-word-matter-viewer.component';
import { TopNavBarButtonComponent } from './top-nav-bar/top-nav-bar-button/top-nav-bar-button.component';

const components = [
	ActingForDropdownComponent,
	BusinessDocumentEditorComponent,
	BusinessUserComponent,
	BusinessUserFilterComponent,
	BusinessUserSelectComponent,
	BusinessUserSelectDropdownComponent,
	CompanyAddComponent,
	CreateEmployeeComponent,
	DocumentDialogComponent,
	DocumentTreeComponent,
	DocumentsMatterEditorComponent,
	DocumentsMatterViewerComponent,
	EncryptedInputComponent,
	FileUploadComponent,
	HtmlEditorComponent,
	HtmlMiniEditorComponent,
	LawyerClerkInitialsComponent,
	LenderComponent,
	LoadingComponent,
	MatterHtmlPdfViewerComponent,
	MatterUserSelectOrSearchComponent,
	MultipleUrlPdfViewerComponent,
	MultipleUserSearchComponent,
	PdfModalComponent,
	ProceedModalComponent,
	ProgressCircleComponent,
	CreateCompanySideFormComponent,
	CreateEmployeeSideFormComponent,
	StewartOAuthLoginComponent,
	SideFlyOutComponent,
	UserPresenceComponent,
	PdftronComponent,
	DocumentsMatterViewtorComponent,
	DocumentSettingsComponent,
	TagsDefinitionDialogComponent,
	MatterUrlPdfViewerComponent,
	ClientIdUploadComponent,
	SaleFileUploadComponent,
	UploadFileStatusComponent,
	ViewAsDropdownComponent,
	MatterFormViewerComponent,
	MatterFormViewerModalComponent,
	MatterStatusIndicatorComponent,
	NotesComponent,
	TopNavBarButtonComponent,
	ContactAdminUsersComponent,
	TableGeneratorDialogComponent,
	MatterTileComponent,
	MatterTypeIconComponent,
	MatterCountIconsComponent,
	MatterPreviewComponent,
	ContactNameBadgeComponent,
	LenderSelectorComponent,
	LenderSearchInputComponent,
	LenderSearchInputV2Component,
	FinancialInstitutionBranchSearchComponent,
	LenderCardComponent,
	InstitutionCardComponent,
	ContactDetailsComponent,
	PayoutMessageComponent,
	ClientSearchInputComponent,
	ClientLenderCardComponent,
	MatterFormViewerContainerComponent,
	InstitutionImgComponent,
	InvestorCardComponent,
	EncumbranceInstitutionCardComponent,
	InsitutionSearchComponent,
	MatterStatusTileComponent,
	GoogleImageComponent,
	PoweredByTreefortComponent,
	FormInstanceViewerComponent,
	ShortfallExcessConformationModalComponent,
	MatterFileCardComponent,
	AddressComponent,
	DocumentTreeWordComponent,
	BusinessUserDropdownComponent,
	AiDocumentProcessingProgressBarComponent,
	DocumentsWordMatterViewerComponent,
	LogoDrawerComponent,
];

@NgModule({
	declarations: [...components],
	imports: [
		IconsModule,
		UiModule,
		AtomicModule,
		CoreModule,
		CommonModule,
		FormsModule,
		MatInputModule,
		NgCircleProgressModule,
		EditorModule,
		RouterModule,
		MatDialogModule,
		MatMenuModule,
		MatTooltipModule,
		ScrollingModule,
		NgClickOutsideDirective,
		ScrollingModule,
	],
	exports: [...components],
})
export class ComponentsModule {}
